import { Component, Fragment, Prop, h } from '@stencil/core';

import { onAcceptOffer } from '../../../../actions/actions.kelley-buys-your-car-offer';
import { trackKelleyBuysYourCarAcceptedModalImpression, trackKelleyBuysYourCarModalCta } from '../../../../tracking/tracking.unified-disposal';
import { AcceptedMessage, LegalText } from '../Shared';

@Component({
  tag: 'kelley-buys-your-car-accept-dialog',
  styleUrl: 'kelley-buys-your-car-accept-dialog.css',
})
export class KelleyBuysYourCarAcceptDialog {
  @Prop() offerAmount: string = '';
  @Prop() isDisposalAccepted: boolean = false;
  @Prop() isSubmitting: boolean = false;
  @Prop() isFakeDoor: boolean = false;
  @Prop({ mutable: true }) modal: HTMLIcoModalElement;

  handleClickAccept = () => {
    trackKelleyBuysYourCarModalCta();
    onAcceptOffer();
  };

  render() {
    const header = !this.isDisposalAccepted
      ? 'Ready to move forward and accept your Kelley Buys Offer?'
      : !this.isFakeDoor
        ? 'Congratulations, On Accepting the Kelley Buys Your Car Offer!'
        : 'Thank you for your interest. Unfortunately this option isn’t available. But, you can still use Instant Cash Offer or Private Seller Exchange.';
    const headerContainerClass = { 'max-w-[570px] mdLrg:mb-2 mt-10 mdLrg:mt-5': true, 'mb-4': this.isDisposalAccepted };
    return (
      <ico-modal displayX class="font-open-sans" dataTestId="kbyc-accept" shouldCloseOnBackdrop={false} ref={(el) => (this.modal = el)}>
        <div slot="header" class={headerContainerClass}>
          <h1 class="text-lg font-extrabold font-montserrat">{header}</h1>
        </div>
        {this.renderStep()}
        {!this.isFakeDoor && (
          <div class="mt-6 text-xxs max-sm:mb-9 max-sm:mt-9">
            <LegalText />
          </div>
        )}
      </ico-modal>
    );
  }

  renderStep = () => (!this.isDisposalAccepted ? this.renderConfirmStep() : !this.isFakeDoor ? this.renderAcceptedStep() : '');

  renderConfirmStep() {
    return (
      <Fragment>
        <div class="text-sm font-bold">Kelley Buys Your Car Offer</div>
        <div class="flex max-sm:flex-col sm:flex-row justify-between max-sm:items-start sm:items-center mdLrg:mt-2 max-sm:gap-6">
          <div class="text-5xl font-bold text-clrs-green" data-testid="kbyc-offer-price">
            {this.offerAmount}
          </div>
          <ico-button
            label={this.isSubmitting ? '...' : 'Yes!'}
            buttonSize="large"
            class="max-sm:w-full sm:w-auto h-full w-[87px]"
            onClick={this.handleClickAccept}
            disabled={this.isSubmitting}
            data-testid="confirm-kbyc-offer-btn"
          />
        </div>
      </Fragment>
    );
  }

  renderAcceptedStep() {
    trackKelleyBuysYourCarAcceptedModalImpression();
    return (
      <div class="max-w-[600px]">
        <AcceptedMessage />
      </div>
    );
  }
}
